class Home {
  constructor (opts = {}) {
    this.bindEvent();
    $('.tabs>.tab:first-child').trigger('mouseenter');
  }

  bindEvent () {
    $('.tab').hover((e) => {
      const $el = $(e.target);
      const index = $el.index();
      $el
        .addClass('active')
        .siblings('.tab')
        .removeClass('active');
      $el
        .parents('.card')
        .find('.tab-panel')
        .eq(index)
        .addClass('active')
        .siblings()
        .removeClass('active');
      const { today, total, path } = $el.data();
      $el
        .parents('.card')
        .find('[name=today]')
        .text(`${today}条`);
      $el
        .parents('.card')
        .find('[name=total]')
        .text(`${total}条`);
      // 有tab的模块，根据选中的tab标签来设置“更多”的跳转链接
      const $more = $el.parents('.card').find('.card__extra,.card__link');
      if (path && $more) {
        // 若链接index.html结尾，则说明是静态之后的
        if ($more.attr('href').indexOf('.html') > -1) {
          $more.attr('href', $more.attr('href').replace(/^\/.*\.html/, path));
        } else {
          $more.attr('href', path);
        }
      }
    });
  }
}

module.exports = Home;
